import React from 'react';

import { tokenInfo } from '../lib/tokens';
import { reactAppApiUrl } from '../api';
import Image from './Image';

const SymbolIcon = ({ style, as, children, symbol, address = '', ...props }) => {
  // test srcs url(s) before updating
  const { [symbol]: { img } = {} } = tokenInfo;
  const urls = [
    img,
    `/images/tokens/${symbol}.png`,
    `${reactAppApiUrl}/tokens/${address}/logo`,
    // default/final fallback
    '/ethereum.png',
  ];

  return (
    <Image as={as} srcs={urls} style={{ ...style }} {...props}>
      {children}
    </Image>
  );
};

export default SymbolIcon;
